// extracted by mini-css-extract-plugin
export var blue = "_24-f";
export var brand = "_24-b";
export var darkGrey = "_24-e";
export var disabled = "_24-4";
export var disabledSubtle = "_24-5";
export var error = "_24-6";
export var green = "_24-g";
export var grey = "_24-d";
export var icon = "_24-0";
export var inherit = "_24-a";
export var lightGrey = "_24-c";
export var orange = "_24-i";
export var pink = "_24-k";
export var primary = "_24-1";
export var purple = "_24-l";
export var red = "_24-j";
export var secondary = "_24-2";
export var success = "_24-9";
export var tertiary = "_24-3";
export var warning = "_24-7";
export var warningSecondary = "_24-8";
export var white = "_24-m";
export var yellow = "_24-h";